import { useState } from 'react'
import { ScoopButton, ScoopSpinner, ScoopTextField } from '../../../ui'
import styles from './LoginForm.module.scss'
import { federatedSignIn } from '../../../../api/auth'
import GoogleIcon from '../../../../assets/account/GoogleIcon.svg'

export const LoginForm = ({
    onToggleMode,
    signInUser,
    handleSignInInputChange,
    handleSignIn,
    isSignInLoading,
    errors,
    setStep,
    forceUserEmail,
    hasInvitation,
}) => {
    const [showPassword, setShowPassword] = useState(false)

    const handleSubmit = (event) => {
        event.preventDefault()
        handleSignIn()
    }

    const handleGoogleLogin = () => {
        try {
            window.dataLayer.push({ event: 'google_login_attempt' })
        } catch (e) {}
        federatedSignIn()
    }

    const togglePassword = () => {
        setShowPassword(!showPassword)
    }

    return (
        <div className={styles.signupContainer}>
            {hasInvitation ? (
                <div className={styles.formHeader}>
                    <span className={styles.trialBadge}>🎉 You're invited to join Scoop!</span>
                    <h2>Sign In to Accept Invitation</h2>
                    <p>You've been invited to join a workspace</p>
                </div>
            ) : (
                <div className={styles.formHeader}>
                    <span className={styles.trialBadge}>Welcome Back</span>
                    <h2>Sign In to Your Account</h2>
                    <p>Continue your analytics journey</p>
                </div>
            )}

            {!forceUserEmail && (
                <>
                    <div className={styles.socialLogin}>
                        <ScoopButton
                            variant="outline"
                            size="fullWidth"
                            onClick={handleGoogleLogin}
                            leftSection={
                                <img src={GoogleIcon} alt="Google" width="18" height="18" />
                            }
                        >
                            Continue with Google
                        </ScoopButton>
                    </div>

                    <div className={styles.divider}>
                        <span>or sign in with email</span>
                    </div>
                </>
            )}

            <form onSubmit={handleSubmit}>
                <div className={styles.formGroup}>
                    <ScoopTextField
                        label="Work Email"
                        type="email"
                        id="email"
                        name="email"
                        placeholder="you@company.com"
                        value={signInUser.email}
                        onChange={(e) => handleSignInInputChange('email', e.target.value)}
                        disableMargin
                        padding="11px 14px"
                        disabled={forceUserEmail !== null}
                    />
                    {errors.email && <div className={styles.errorText}>{errors.email}</div>}
                </div>

                <div className={styles.formGroup}>
                    <div className={styles.passwordWrapper}>
                        <ScoopTextField
                            label="Password"
                            type={showPassword ? 'text' : 'password'}
                            id="password"
                            name="password"
                            placeholder="Enter your password"
                            value={signInUser.password}
                            onChange={(e) => handleSignInInputChange('password', e.target.value)}
                            disableMargin
                            height="40px"
                        />
                        <button
                            type="button"
                            className={styles.passwordToggle}
                            onClick={togglePassword}
                        >
                            {showPassword ? 'Hide' : 'Show'}
                        </button>
                    </div>
                    {errors.password && <div className={styles.errorText}>{errors.password}</div>}
                </div>

                <ScoopButton
                    variant="default"
                    size="fullWidth"
                    type="submit"
                    disabled={isSignInLoading}
                >
                    {isSignInLoading ? <ScoopSpinner /> : 'Sign In'}
                </ScoopButton>

                <div className={styles.terms}>
                    By signing in, you agree to our{' '}
                    <a href="https://www.scoopanalytics.com/toc" target="_blank" rel="noreferrer">
                        Terms of Service
                    </a>{' '}
                    and{' '}
                    <a
                        href="https://www.scoopanalytics.com/privacy-policy"
                        target="_blank"
                        rel="noreferrer"
                    >
                        Privacy Policy
                    </a>
                </div>
            </form>

            <div className={styles.loginLink}>
                Don't have an account? <span onClick={onToggleMode}>Sign up</span>
            </div>
            <div className={styles.forgotPassword}>
                Forgot your password?{' '}
                <span className={styles.forgotLink} onClick={() => setStep(2)}>
                    Recover it here
                </span>
            </div>
        </div>
    )
}
